import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";

// material-ui
import { makeStyles } from '@material-ui/styles';
import { Divider, List, Typography, Chip } from '@material-ui/core';

// project imports
import NavItem from 'layout/MainLayout/Sidebar/MenuList/NavItem';
import NavCollapse from 'layout/MainLayout/Sidebar/MenuList/NavCollapse';

const getRoleId = (token) => {
    if (!token) return null;

    try {
        const decoded = jwtDecode(token);
        return decoded.role_id || null; // Adjust based on your JWT payload structure
    } catch (error) {
        console.error("Invalid token:", error);
        return null;
    }
};

// style constant
const useStyles = makeStyles((theme) => ({
    menuCaption: {
        ...theme.typography.menuCaption
    },
    subMenuCaption: {
        ...theme.typography.subMenuCaption
    },
    menuDivider: {
        marginTop: '2px',
        marginBottom: '10px'
    }
}));

//-----------------------|| SIDEBAR MENU LIST GROUP ||-----------------------//

const NavGroup = ({ item }) => {
    const classes = useStyles();
    const account = useSelector((state) => state.account);
    const roleId = getRoleId(account.token);

    // menu list collapse & items
    const items = item.children.map((menu) => {
        switch (menu.type) {
            case 'collapse':
                return <NavCollapse key={menu.id} menu={menu} level={1} />;
            case 'item':
                if (!menu.accessRoles || menu.accessRoles.includes(roleId)) {
                    return <NavItem key={menu.id} item={menu} level={1} />;
                }
                return null;
            default:
                return (
                    <Typography key={menu.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return (
        <React.Fragment>
            <List
                subheader={
                    item.title && (
                        <Typography variant="caption" className={classes.menuCaption} display="block" gutterBottom>
                            {item.title}
                            {item.caption && (
                                <Typography variant="caption" className={classes.subMenuCaption} display="block" gutterBottom>
                                    {item.caption}
                                </Typography>
                            )}
                        </Typography>
                    )
                }
            >
                {items}
            </List>

            {/* group divider */}
            <Divider className={classes.menuDivider} />
        </React.Fragment>
    );
};

NavGroup.propTypes = {
    item: PropTypes.object
};

export default NavGroup;
